import {Box, Divider, P} from 'exsportia-components'
import React, {FC, PropsWithChildren} from 'react'

type Props = {
  title: string
  withPL?: boolean
}
export const TitledSection: FC<PropsWithChildren<Props>> = ({title, withPL, children}) => {
  return (
    <Box>
      <Box
        pt='16px'
        pl={withPL ? '16px' : 0}
      >
        <P
          fontSize={'h2'}
          fontWeight={'bold'}
        >
          {title}
        </P>
      </Box>
      <Box pt={'8px'}>
        {children && Array.isArray(children)
          ? children.reduce<React.ReactNode[]>((acc, val, i) => {
              if (i !== children.length - 1 && typeof val === 'object') {
                return acc.concat(
                  val as React.ReactNode,
                  <Divider key={`divider-${i}`} />,
                )
              }
              return acc.concat(val as React.ReactNode)
            }, [])
          : children}
      </Box>
    </Box>
  )
}
